export default __webpack_public_path__ + "static/media/a028-3.ce083517.svg";